<div class="container-fluid">
  <div class="card">
    <div class="card-body">
      <div [hidden]="!hasRouteAccess(routes.SECURE.SETTLEMENT_BATCH.VIEW)" class="form-group">
        <div [hidden]="hideOutstandingAvsVerificationMessage" class="outstanding-avs-message">
          <p>
            <i class="fa fa-info-circle"></i> Please note that your banking details are not yet verified. No
          settlement will take place until the verification is completed </p>
        </div>
        <div class="card" style="margin-bottom: 2rem">
          <div class="card-header" style="margin-bottom: 0">
            <h6>Settlement Summary for {{ getDate() | date: 'MMMM yyyy' }}</h6>
          </div>
          <div class="card-body settlement-summary-card-details">
            <div class="col-md-4">
              <td>
                <span class="summary-label">Total Transactions</span>
                {{ settlementSummary?.totalTransactions }}
              </td>
            </div>
            <div class="col-md-4">
              <td>
                <span class="summary-label">Total Amount</span>
                {{ settlementSummary?.totalAmount | toMajor | currency: 'R ' }}
              </td>
            </div>
            <div class="col-md-4">
              <td>
                <span class="summary-label">Total Amount Settled</span>
                {{ settlementSummary?.totalAmountSettled | toMajor | currency: 'R ' }}
              </td>
            </div>
          </div>
        </div>
        <div [hidden]="hideSettlementDetails" class="margin-top-bottom">
          <h3>
            <i class="fa fa-info-circle"></i>
            <span [hidden]="settlementDetails?.minimumSettlementAmount === 0"> The minimum settlement amount is {{ settlementDetails?.minimumSettlementAmount | toMajor | currency: 'R ' }}</span>
            <span [hidden]="settlementDetails?.settlementFee === 0">
              @if (settlementDetails?.minimumSettlementAmount !== 0) {
                <span>
                  , with a settlement fee of {{ getSettlementFeeInclVat() | toMajor | currency: 'R ' }}
                  (VAT included) per settlement
                </span>
              } @else {
                <span>
                  There is a settlement fee of {{ getSettlementFeeInclVat() | toMajor | currency: 'R ' }}
                  (VAT included) per settlement
                </span>
              }
            </span>
          </h3>
        </div>
        <div [hidden]="isResultListEmpty()" class="margin-top-bottom">
          <h3>
            <i class="fa fa-info-circle"></i> No settlement batch found. </h3>
          </div>
          <app-search-view>
            <app-batch-search #app filters></app-batch-search>
            <table class="table table-hover table-responsive-md table-wrap-sm" grid>
              <thead>
                <tr>
                  <th #batchNumber
                    (click)="applySorting(batchNumber.id, app)"
                    class="sort-field"
                    id="batchNumber"
                    scope="col">Batch Number
                    <em class="{{ isDesc(batchNumber.id) ? 'fa fa-sort-desc': isAsc(batchNumber.id) ? 'fa fa-sort-asc':'fa fa-sort'}}"></em>
                  </th>
                  <th #totalTransactions
                    (click)="applySorting(totalTransactions.id, app)"
                    class="sort-field"
                    id="totalTransactions"
                    scope="col">
                    Number of Payments
                    <em class="{{ isDesc(totalTransactions.id) ? 'fa fa-sort-desc': isAsc(totalTransactions.id) ? 'fa fa-sort-asc':'fa fa-sort'}}"></em>
                  </th>
                  <th #totalAmount
                    (click)="applySorting(totalAmount.id, app)"
                    class="sort-field"
                    id="totalAmount"
                    scope="col">
                    Total Amount
                    <em class="{{ isDesc(totalAmount.id) ? 'fa fa-sort-desc': isAsc(totalAmount.id) ? 'fa fa-sort-asc':'fa fa-sort'}}"></em>
                  </th>
                  <th #totalTransactionFeesInclVat
                    (click)="applySorting(totalTransactionFeesInclVat.id, app)"
                    class="sort-field"
                    id="totalTransactionFeesInclVat"
                    scope="col">
                    Transaction Fees (Incl. VAT)
                    <em class="{{ isDesc(totalTransactionFeesInclVat.id) ? 'fa fa-sort-desc': isAsc(totalTransactionFeesInclVat.id) ? 'fa fa-sort-asc':'fa fa-sort'}}"></em>
                  </th>
                  <th #settlementFeeInclVat
                    (click)="applySorting(settlementFeeInclVat.id, app)"
                    class="sort-field"
                    id="settlementFeeInclVat"
                    scope="col">
                    Settlement Fee (Incl. VAT)
                    <em class="{{ isDesc(settlementFeeInclVat.id) ? 'fa fa-sort-desc': isAsc(settlementFeeInclVat.id) ? 'fa fa-sort-asc':'fa fa-sort'}}"></em>
                  </th>
                  <th #totalAmountSettled
                    (click)="applySorting(totalAmountSettled.id, app)"
                    class="sort-field"
                    id="totalAmountSettled"
                    scope="col">
                    Settlement Amount
                    <em class="{{ isDesc(totalAmountSettled.id) ? 'fa fa-sort-desc': isAsc(totalAmountSettled.id) ? 'fa fa-sort-asc':'fa fa-sort'}}"></em>
                  </th>
                  <th #dateTimeUpdated
                    (click)="applySorting(dateTimeUpdated.id, app)"
                    class="sort-field"
                    id="dateTimeUpdated"
                    scope="col">
                    Last Updated
                    <em class="{{ isDesc(dateTimeUpdated.id) ? 'fa fa-sort-desc': isAsc(dateTimeUpdated.id) ? 'fa fa-sort-asc':'fa fa-sort'}}"></em>
                  </th>
                  <th #batchStatus id="batchStatus" scope="col">
                    Status <i class="pi pi-question-circle tooltip-icon"
                  pTooltip="{{getBatchStatusUtil().getDescriptionOfAllStatuses()}}"></i>
                </th>
                <th class="text-center" scope="col">
                  Recon File <i class="pi pi-question-circle tooltip-icon"
                pTooltip="{{getReconFileTooltipText()}}"></i>
              </th>
            </tr>
          </thead>
          <tbody class="table-hover text-nowrap">
            @for (batch of contents; track batch) {
              <tr class="cursor-pointer  active-color">
                <td (click)="view(batch)">
                  <span class="p-column-title">Batch Number</span>
                  {{ batch.batchNumber }}
                </td>
                <td (click)="view(batch)">
                  <span class="p-column-title">Number of Payments</span>
                  {{ batch.totalTransactions }}
                </td>
                <td (click)="view(batch)">
                  <span class="p-column-title">Total Amount</span>
                  {{ batch.totalAmount | toMajor | currency: 'R ' }}
                </td>
                <td (click)="view(batch)">
                  <span class="p-column-title">Transaction Fees (Incl. VAT)</span>
                  {{ batch.totalTransactionFeesInclVat | currency: 'R ' }}
                </td>
                <td (click)="view(batch)">
                  <span class="p-column-title">Settlement Fees (Incl. VAT)</span>
                  {{ batch.settlementFeeInclVat | currency: 'R ' }}
                </td>
                <td (click)="view(batch)">
                  <span class="p-column-title">Settlement Amount</span>
                  {{ batch.totalAmountSettled | toMajor | currency:'R ' }}
                </td>
                <td (click)="view(batch)">
                  <span class="p-column-title">Last Updated</span>
                  {{ batch.dateTimeUpdated | amFromUtc | amLocal | amDateFormat: 'YYYY-MM-DD HH:mm:ss' }}
                </td>
                <!-- container="body" is required to prevent tooltips from adding an empty cell to the table when displayed -->
                <td (click)="view(batch)"
                  [style.color]="getBatchStatusUtil().getTextColor(batch.batchStatus)"
                  pTooltip="{{getBatchStatusUtil().getLongDescription(batch.batchStatus)}}">
                  <span class="p-column-title">Status</span>
                  {{ batch.batchStatus | getBatchStatusDescription }}
                </td>
                <td>
                  <div class="text-center">
                    <div class="disabled-tooltip-wrapper"
                      [pTooltip]="isGuestAdminUser() ? 'Guest accounts cannot download account recon files.' : null">
                      <div (click)="getAccountReconFile(batch)"
                        [class.grey-circle-style]="isGuestAdminUser()"
                        [hidden]="!getBatchStatusUtil().isClosedSettlementBatch(batch.batchStatus)"
                        class="circle-style"
                        [pTooltip]="!(isReconFileDownloadable(batch) || isGuestAdminUser()) ? getDisabledReconFileDownloadToolTip() : null">
                        <i class="fa fa-download fa-lg"></i>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </app-search-view>
    </div>
  </div>
</div>
</div>